export const focusWorkspace = (id: string) => {
  const iframe = document.getElementById(id) as HTMLIFrameElement;
  const iWindow = iframe?.contentWindow;
  iWindow?.focus();
};

export const updateDocumentTitle = (title: string) => {
  document.title = title;

  if (document.querySelector('meta[property="og:title"]')) {
    document
      .querySelector('meta[property="og:title"]')!
      .setAttribute("content", title);
  }

  if (document.querySelector('meta[property="og:url"]')) {
    document
      .querySelector('meta[property="og:url"]')!
      .setAttribute("content", document.location.href);
  }
};

export const getDocumentTitle = () => {
  return document.title;
};
